// extracted by mini-css-extract-plugin
module.exports = {"list":"subjects_list__WwgC3"};